<template>
	<HorizontalNavbar
		v-if="categories.length > 0"
		class="desktop-center"
		ref="horizontalNavbar"
		:options="categories"
		:stickyEnabled="stickyEnabled"
		:isSticky="true"
		@optionSelected="scrollToSelectedCategory"
	/>
</template>

<script>
import HorizontalNavbar from "@/components/common/HorizontalNavbar.vue"

export default {
	name: "MenuCategoryNavbar",
	components: {
		HorizontalNavbar
	},
	props: {
		categorizedMenu: Array,
		stickyEnabled: Boolean
	},
	data: function () {
		return {
			selectedCategory: {
				id: null
			}
		}
	},
	computed: {
		categories() {
			const categoryIds = []
			const categories = this.categorizedMenu
				.map((menu) =>
					menu.categories
						.filter((category) => {
							if (!categoryIds.includes(category.categoryId)) {
								categoryIds.push(category.categoryId)
								return category.categoryId != -1
							}
							return false
						})
						.map((category, i) => {
							const selected =
								(i == 0 && !this.selectedCategory.id) ||
								category.categoryId == this.selectedCategory.id
							return {
								id: category.categoryId,
								text: category.categoryName,
								selected: selected
							}
						})
				)
				.flat()

			return categories
		}
	},
	methods: {
		setCategoryId(categoryId) {
			if (categoryId == this.selectedCategory.id) {
				return
			}

			this.selectedCategory.id = categoryId
			if (this.$refs.horizontalNavbar) {
				this.$refs.horizontalNavbar.scrollToSelectedOption({
					id: categoryId
				})
			}
		},
		scrollToSelectedCategory(option) {
			this.selectedCategory = option
			this.$emit("scrollToSelectedCategory", option)
		}
	}
}
</script>